import { useState, useEffect } from "react";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import * as http from "../../utils/http";
import LoadingModal from "../../components/Modals/LoadingModal/LoadingModal";
import ServerError from "../../components/ServerError/ServerError";
import { MainTracker } from "../../PixelTrackers/MainTracker";
import { trackReorderPaid } from "../Reorder/ReorderTrackingManager";
import { getPaymentMethodType } from "./paymentService";
import { readPrimerPendingPayment, clearPrimerPendingPayment } from "./providers/primerHelpers";
import { getCheckoutProviderAdapter } from "./providers";

const positives = ['true', 1, true, '1']

export default function PaymentPageCallBack(props) {
  const [error, setError] = useState("");
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();

  let langauge = searchParams.get("language");
  let country = searchParams.get("country");
  let hashID = searchParams.get("hashID");
  let thankyouHash = searchParams.get("thankyouHash");
  let paymentTypeID = searchParams.get("paymentTypeID");
  let isSubscription = positives.includes(searchParams.get("isSubscription"));

  let age = searchParams.get("a");
  let ord = searchParams.get("ord");
  let gender = searchParams.get("g");
  const cat = searchParams.get("cat");
  const pm = searchParams.get("pm");
  const psp = searchParams.get("psp");
  const checkout = searchParams.get("checkout");
  // The attempt the server built this return URL for (Adyen / Stripe; Primer builds its own URL without it)
  const transactionID = searchParams.get("tx");

  // Only these statuses should redirect to thank-you page
  const successStatuses = ["Authorised", "Received"];

  useEffect(() => {
    if (window.eventsTracking.getData("last_paid_order") === hashID){
      setError(true)
      window.clientLogger.warn(`check3ds after payment was already paid`,{hashID});
      return;
    }

    const matchFbpCookie = document.cookie.match(/_fbp=([^;]+)/);
    const fbpCookie = matchFbpCookie ? matchFbpCookie[1] : '';
    
    // Primer checkout: the payment id was saved before a redirect method left the page. A return
    // URL naming an attempt of another PSP is never Primer's, whatever an older Primer attempt saved.
    const primerPaymentId = readPrimerPendingPayment(hashID);
    const isPrimerCheckout = !(transactionID && psp !== "primer") && (checkout === "primer" || !!primerPaymentId);
    const adapter = getCheckoutProviderAdapter(isPrimerCheckout ? "primer" : psp) ?? getCheckoutProviderAdapter("adyen");
    const body = {
      psp,
      checkout,
      ...(transactionID && { transactionID }),
      hashID,
      paymentTypeID,
      isSubscription,
      fbpCookie,
      ...adapter.readRedirectReturn(searchParams, hashID),
    };

    http.postToServer(`payment/check_3ds_status`, body, [http.MIDDLEWARES.CUSTOMER_ID])
    .then((response) => {
      const resultCode = response.data.resultCode;
      if (isPrimerCheckout) {
        clearPrimerPendingPayment();
      }
      window.clientLogger.info("STATUS:", {response: response.data, resultCode});

      // Only redirect to thank-you for successful payment statuses
      if (successStatuses.includes(resultCode)) {
        // Track reorder paid event
        trackReorderPaid(response.data.providerResponse?.amount / 100, cat);
        // save paid in client - in order to not load payment page
        window.eventsTracking.setData("last_paid_order", hashID)
        window.eventsTracking.setData("last_order_action", Date.now())
        const tpp = localStorage.getItem('dhl_next_day_displayed');
        localStorage.removeItem('dhl_next_day_displayed');
        navigate({
          pathname: `/thank-you/${country}/${langauge}/${hashID}`,
          search: createSearchParams({
            result: resultCode,
            thankyouHash: thankyouHash,
            a: age,
            ord,
            g: gender,
            cat,
            pm: pm || getPaymentMethodType(response.data),
            psp: response.data.claimedProvider ?? psp,
            ...(isPrimerCheckout ? { checkout: "primer" } : {}),
            ...(tpp ? { tpp } : {}),
          }).toString(),
        });
        return;
      }

      // All other statuses (Cancelled, Refused, UnknownCode, etc.) redirect back to payment page
      window.clientLogger.warn("Payment not successful, redirect to payment page", { resultCode });
      navigate({
        pathname: `/payment/${country}/${langauge}/${hashID}/`,
        search: createSearchParams({
          result: resultCode,
          rr : response.data.rr,
          stripeErrorMessage: response.data.providerResponse?.last_payment_error?.message || resultCode
        }).toString(),
      });
    })
    .catch((error) => {
      setError("error");
      MainTracker.track('custom', 'Payment Error',{
        paymentMethod:pm,
        paymentSource:"3ds",
        paymentTypeID,
        hashID,
        orderID:ord,
        catalog:cat
      });
    });
  }, []);

  return (
    <div>
      {error && <ServerError status={error} />}
      {!error && (
        <span>
          <LoadingModal />
        </span>
      )}
    </div>
  );
}
